module.exports = __webpack_public_path__ + "media/images/cashnetusa_logo-dcd12b00.png";